import TEXTS from "../controller/TextVariables";

const SVIBanner = () => {
    return (
        <div id="svi-banner" className="control">
            <div id="banner-text">
                <h3>{TEXTS.cdc_banner}</h3>
                <h4>{TEXTS.svi}</h4>
            </div>
            <div id="grasp_logo" />
        </div>
    );
};
export default SVIBanner;
